export { default as NewsFeed } from './NewsFeed';
